import fetch from 'isomorphic-fetch';

export const ActionTypes = {
  RENDER_DETAIL: 'zola/cards/pdp/RENDER_DETAIL',
  DETAIL_ADMIN_VIEW: 'zola/cards/plp/DETAIL_ADMIN_VIEW',
  SET_INITIAL_PRODUCT_COLOR: 'zola/cards/pdp/SET_INITIAL_PRODUCT_COLOR',
};

const handleErrors = (response) => {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
};

// export const selectFormType = payload => ({
//   type: ActionTypes.SELECT_FORM_TYPE,
//   payload,
// });

// export const selectEventType = payload => ({
//   type: ActionTypes.SELECT_EVENT_TYPE,
//   payload,
// });

// export const selectWrapType = payload => ({
//   type: ActionTypes.SELECT_WRAP_TYPE,
//   payload,
// });

const renderDetailPage = payload => ({
  type: ActionTypes.RENDER_DETAIL,
  payload,
});

export const updateDetailAdminView = isAdminView => ({
  type: ActionTypes.DETAIL_ADMIN_VIEW,
  payload: {
    isAdminView
  }
});

// export const selectEventTypeAsync = eventType => (dispatch) => { // eslint-disable-line
//   return new Promise((resolve) => {
//     dispatch(selectEventType(eventType));
//     resolve();
//   });
// };

export function setInitialProductColor(color) {
  return {
    type: ActionTypes.SET_INITIAL_PRODUCT_COLOR,
    payload: {
      color
    }
  };
}

export const fetchCardFullDetail = (productId, isAdminView = false) => (
  (dispatch, getState) => { // eslint-disable-line
    // const state = getState();
    const queryParams = isAdminView ? '?admin_view=true' : '';

    return fetch(`/web-api/v1/card-product/${productId}/full-detail${queryParams}`,
      {
        credentials: 'same-origin',
        method: 'GET',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(renderDetailPage(json));
        return json;
      });
    // .catch(err => console.warn(err));
  }
);

export const fetchProductBySkuObjectId = skuObjectId => (
  (dispatch, getState) => { // eslint-disable-line
    // const state = getState();
    // const queryParams = isAdminView ? '?admin_view=true' : '';

    return fetch(`/web-api/v1/card-product/${skuObjectId}/product_view`,
      {
        credentials: 'same-origin',
        method: 'GET',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(renderDetailPage(json));
        return json;
      });
    // .catch(err => console.warn(err));
  }
);



/** WEBPACK FOOTER **
 ** ./src/cards/actions/cardDetailActions.js
 **/